import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';
import type { BlockVisualization } from 'webapp/enums/enums';

import BlockSettingsVisualizationSwitchConfirmComponent from 'webapp/components/block/settings/visualization-switch-confirm';
import BlockSettingsVisualizationsGridComponent from 'webapp/components/block/settings/visualizations-grid';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

import type { ChangeVisualizationWithPossibleConfirmFnReturnType } from 'webapp/models-custom/block-setup';

export default class BlockPopupVisualizationComponent extends PopupInnerContextComponent<PopupData.Block.Visualization> {
	@service('model-manager/blocks') declare mmBlocksService: Service.ModelManager.Blocks;

	get selectedBlockSetup() {
		return this.popupData.selectedBlockSetup;
	}

	get selectedVisualizationType() {
		return this.selectedBlockSetup.visualizationType;
	}

	get options() {
		return this.popupData.options;
	}

	// ----- Visualization change -----

	@tracked changeVisualizationConfirmRecordLimit = 1;

	@tracked onVisualizationChangeConfirm: ChangeVisualizationWithPossibleConfirmFnReturnType =
		null;

	get showChangeVisualizationConfirm() {
		return !!this.onVisualizationChangeConfirm;
	}

	@action
	changeVisualization(toVisualizationType: BlockVisualization): void {
		this.onVisualizationChangeConfirm = this.popupData.onChange(toVisualizationType);
		this.changeVisualizationConfirmRecordLimit =
			this.selectedBlockSetup.getMaxPrimaryMainDataSelectsAllowed(toVisualizationType);
		if (this.showChangeVisualizationConfirm) {
			this.scheduleReposition();
		} else {
			this.close();
		}
	}

	@action
	confirmVisualizationChange() {
		const onConfirm = this.onVisualizationChangeConfirm;
		if (onConfirm) {
			onConfirm();
		}
		this.close();
	}

	@action
	rejectVisualizationChange() {
		this.onVisualizationChangeConfirm = null;
	}
	<template>
		<BlockSettingsVisualizationsGridComponent
			@selected={{this.selectedVisualizationType}}
			@onChange={{this.changeVisualization}}
			@options={{this.options}}
		/>

		{{#if this.showChangeVisualizationConfirm}}
			<BlockSettingsVisualizationSwitchConfirmComponent
				@max={{this.changeVisualizationConfirmRecordLimit}}
				@onConfirm={{this.confirmVisualizationChange}}
				@onReject={{this.rejectVisualizationChange}}
			/>
		{{/if}}
	</template>
}
